<template>
  <div>
    <div>
      <!-- 搜索 -->
      <table-search
        @search="fetchList(1)"
        @reset="handleReset"
      >
        <template v-slot:basic>
          <el-form-item label="交易方向">
            <el-select
              v-model="query.tag"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in $key.myStore.orderTag"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="商品类目"
            class="datePicker"
          >
            <el-select
              v-model="query.varietyCode"
              placeholder="请选择"
              clearable
              @change="selectVarietyChange"
            >
              <el-option
                v-for="(item) in varietyList"
                :key="item.code"
                :label="item.shortName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="商品品牌">
            <el-select
              v-model="query.goodsBrandCode"
              placeholder="请选择"
              clearable
              @change="selectBrandChange"
            >
              <el-option
                v-for="item in brandList"
                :key="item.k"
                :label="item.v"
                :value="item.k"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select
              v-model="query.reserveType"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in $key.myStore.reserveType"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="交货地点"
          >
            <el-input v-model.trim="query.pickupPosition" />
          </el-form-item>
          <el-form-item
            label="下单时间"
          >
            <template v-slot="scope">
              <el-date-picker
                v-model="pickData"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
            </template>
          </el-form-item>
        </template>
      </table-search>

      <!-- 导出 -->
      <inquery-result
        :is-export="false"
      />

      <!-- 表格 -->
      <el-table
        ref="zTable"
        :data="tableData"
        @selection-change="handleSelectionChange"
      >
        <af-table-column
          prop="reserveUserName"
          label="交易对手方"
        >
          <template v-slot="scope">
            {{ scope.row.tag==='S'? scope.row.reserveUserName : scope.row.tenderUserName }}
          </template>
        </af-table-column>
        <af-table-column
          prop="tag"
          label="交易方向"
        >
          <template v-slot="scope">
            {{ scope.row.tag | keyFilter('myStore','orderTag') }}
          </template>
        </af-table-column>
        <af-table-column
          prop="varietyName"
          label="商品类目"
        />
        <af-table-column
          label="品牌"
        >
          <template v-slot="scope">
            {{ scope.row.attrList.find(item=>item.attrCode==='brand') ? scope.row.attrList.find(item=>item.attrCode==='brand').v : '' }}
          </template>
        </af-table-column>
        <af-table-column
          prop="unitPrice"
          label="单价"
        >
          <template slot-scope="scope">
            {{ scope.row.unitPrice | thousandMark }}
          </template>
        </af-table-column>
        <af-table-column
          prop="quantity"
          label="数量"
        />
        <af-table-column
          prop="totalPrice"
          label="总价"
        >
          <template slot-scope="scope">
            {{ scope.row.totalPrice | thousandMark }}
          </template>
        </af-table-column>
        <af-table-column
          prop="lastUpdateDate"
          label="下单时间"
        />

        <af-table-column
          prop="reserveType"
          label="订单类型"
        >
          <template v-slot="scope">
            {{ scope.row.reserveType | keyFilter('myStore','reserveType') }}
          </template>
        </af-table-column>
        <af-table-column
          prop="pickupPosition"
          label="交货地点"
        />
        <af-table-column
          label="操作"
          fixed="right"
        >
          <template v-slot="scope">
            <el-button
              type="text"
              @click="toOperate('detail',scope.row)"
            >
              详情
            </el-button>
            <el-button
              v-if="scope.row.status==='11'&&scope.row.tag==='S'"
              type="text"
              @click="toOperate('edit',scope.row)"
            >
              确认意向单
            </el-button>
            <el-button
              v-if="scope.row.reserveType!=='FAIL'"
              type="text"
              class="red"
              @click="toCancel(scope.row)"
            >
              取消订单
            </el-button>
          </template>
        </af-table-column>
      </el-table>
      <pagination
        :data="pageData"
        :is-init="false"
        @retrieve="fetchList"
      />
    </div>
    <confirm-order
      v-if="orderConfirmVisible"
      :opt-type="optType"
      :is-show="orderConfirmVisible"
      :detail-data="detailData"
      @close="orderConfirmVisible=false"
      @refresh="fetchList()"
    />
  </div>
</template>
<script>
import api from '@/api'
import { mapState } from 'vuex'
import ConfirmOrder from './components/confirm-order'
import { formatTime } from '@/utils/util'
import { varietyBrandMixin } from '@/views/my-store/components/mixin'

function Query () {
  return {
    currentNo: '1',
    pageSize: '10',
    varietyCode: '',
    reserveType: '',
    startTime: '',
    endTime: '',
    goodsBrandCode: '',
    attrList: [],
    tag: ''
  }
}
export default {
  name: 'StoreOrder',
  components: {
    ConfirmOrder
  },
  mixins: [varietyBrandMixin],
  data () {
    return {
      query: new Query(),
      tableData: [],
      pageData: {},
      detailData: {},
      optType: '',
      quatationList: [],
      orderConfirmVisible: false,
      pickData: [],
    }
  },
  computed: {
    ...mapState({
      userAccount: state => state.user.info.account,
      marketId: state => state.user.info.marketId
    })
  },
  created () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentNo, pageSize) {
      this.query.currentNo = currentNo || this.query.currentNo
      this.query.pageSize = pageSize || this.query.pageSize
      this.query.startTime = this.pickData[0] ? formatTime(this, this.pickData[0]) : ''
      this.query.endTime = this.pickData[1] ? formatTime(this, this.pickData[1], 1) : ''
      let res = await api.myStore.getOrderData({ ...this.query, userAccount: this.userAccount })
      this.tableData = res.data.rows
      this.pageData = res.data
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.pickData = []
      this.fetchList(1)
    },
    async getDetail (row) {
      const res = await api.myStore.getOrderDetail(row.id)
      return res.data
    },
    async toOperate (optType, row) {
      this.detailData = await this.getDetail(row)
      this.optType = optType
      this.orderConfirmVisible = true
    },
    handleSelectionChange (selection) {
      this.quatationList = selection
    },
    // 取消订单
    toCancel (row) {
      this.$confirm('确认取消该订单?', '提示', {
        type: 'warning'
      }).then(() => {
        api.myStore.confirmOrUpdateOrder({ id: row.id, action: '2', version: row.version }).then(res => {
          this.$message.success('操作成功')
          this.fetchList(this.query.currentNo)
        })
      }).catch(() => {

      })
    }

  }
}

</script>
